import React, { memo, useMemo } from 'react';
import classNames from 'classnames/bind';
import { Text } from "../../../Text";
import { getTextColor } from "../../utils/getTextColor";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var StepContent = /*#__PURE__*/memo(function (_ref) {
  var customDescription = _ref.customDescription,
    description = _ref.description,
    isClickable = _ref.isClickable,
    selected = _ref.selected,
    title = _ref.title;
  var titleColor = useMemo(function () {
    return getTextColor({
      isClickable: isClickable,
      selected: selected,
      type: 'title'
    });
  }, [isClickable, selected]);
  var descriptionColor = useMemo(function () {
    return getTextColor({
      isClickable: isClickable,
      selected: selected,
      type: 'description'
    });
  }, [isClickable, selected]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('content'),
    "data-t-id": "components-StepContent"
  }, /*#__PURE__*/React.createElement(Text, {
    color: titleColor,
    extraAttributes: {
      itemProp: 'name'
    },
    size: "size3-m"
  }, title), (description || customDescription) && /*#__PURE__*/React.createElement("div", {
    className: cn('content__description'),
    itemProp: "itemListElement",
    itemScope: true,
    itemType: "https://schema.org/HowToDirection"
  }, /*#__PURE__*/React.createElement(Text, {
    color: descriptionColor,
    extraAttributes: {
      itemProp: 'text'
    },
    size: "size5-r-l"
  }, description), /*#__PURE__*/React.createElement(Text, {
    color: descriptionColor,
    size: "size5-r-l",
    tagType: "div"
  }, customDescription)));
});